module.exports = __webpack_public_path__ + "static/media/SF-11-A (1).574ab2bb.mp3";